import { memo } from 'react'

import type { IIconsProps } from './icons.types'

const IconCheck = ({ width = 24, height = 24, ...props }: IIconsProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.2803 7.34467C19.5732 7.63756 19.5732 8.11243 19.2803 8.40533L10.7803 16.9054C10.6397 17.046 10.4489 17.125 10.25 17.125C10.0511 17.125 9.86032 17.046 9.71967 16.9054L4.71967 11.9054C4.42678 11.6125 4.42678 11.1376 4.71967 10.8447C5.01256 10.5518 5.48744 10.5518 5.78033 10.8447L10.25 15.3144L18.2197 7.34467C18.5126 7.05178 18.9874 7.05178 19.2803 7.34467Z'
        fill='currentColor'
      />
    </svg>
  )
}

export default memo(IconCheck)
